import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useSyncExternalStore } from 'react';

// Shared across every mindset agent surface, so they all see the same extra situational awareness context.
// Merged into the comprehensive payload useMindsetSituationalAwareness builds and pushes to the agent.
var context = {};
var listeners = new Set();
export function updateExtraSituationalAwarenessContext(partial) {
  var next = _objectSpread({}, context);
  var hasChanged = false;
  for (var _i = 0, _Object$entries = Object.entries(partial); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (next[key] === value) continue;
    hasChanged = true;
    if (value === undefined) {
      delete next[key];
    } else {
      next[key] = value;
    }
  }
  if (!hasChanged) return;
  context = next;
  listeners.forEach(function (listener) {
    return listener();
  });
}
function subscribe(listener) {
  listeners.add(listener);
  return function () {
    return listeners.delete(listener);
  };
}

// Also used by callers that need the current value synchronously right after
// calling updateExtraSituationalAwarenessContext, before React has re-rendered.
export function getExtraSituationalAwarenessContext() {
  return context;
}

// useSyncExternalStore is needed as there's no common ancestor  between MindsetAgentDock and embedded surfaces to host a Context provider,
// and getExtraSituationalAwarenessContext() must be readable synchronously outside React's render cycle.
export function useExtraSituationalAwarenessContext() {
  return useSyncExternalStore(subscribe, getExtraSituationalAwarenessContext);
}